import { JsonPipe, NgClass, NgTemplateOutlet, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TableHeader } from '../table-grid/models/table-header';

@Component({
  selector: 'mbs-tile',
  imports: [NgClass, JsonPipe, NgbTooltip, NgTemplateOutlet, TitleCasePipe],
  templateUrl: './tile.component.html'
})
export class TileComponent {
  @Input() statusClass: string;
  @Input() data: any;
  @Input() disabled = false;

  private gridHeaders: TableHeader[];
  @Input()
  set headers(value: TableHeader[]) {
    this.gridHeaders = value.map((h, index) => Object.assign({ id: index }, h)).filter((h) => h.isGridColumn !== false);
  }

  get headers(): TableHeader[] {
    return this.gridHeaders;
  }

  @Input() showBody = true;
  @Input() icon: string;
  @Input() title: string;
  @Input() headerTemplate: TemplateRef<any>;
  @Input() tileTemplate: TemplateRef<any>;
  @Input() templates: TemplateRef<any>[];
  @Input() selected = false;
  @Input() borderedSelected = false;
  @Input() selectable = false;
  @Input() autoDeselect = true;
  @Input() selectedClass = '-selected';
  @Input() hoverAble = true;
  @Input() borderPadding: 'default' | 'none' = 'default';
  @Output() click = new EventEmitter();

  handleClick(event: MouseEvent): void {
    event.stopPropagation();
    if (this.selectable && !this.disabled && this.autoDeselect) {
      this.selected = !this.selected;
    }
    this.click.emit({ ...this.data, event });
  }

  getTileClasses(): string {
    const classes = [`-${this.borderPadding}Padding`];

    if (this.statusClass != null) {
      classes.push(this.statusClass);
    }
    if (this.selectable) {
      classes.push('-selectable');
    }
    if (this.disabled) {
      classes.push('-disabled');
    }
    if (this.selectable && this.selected) {
      classes.push(this.selectedClass);
    }
    if (this.hoverAble) {
      classes.push('-hoverAble');
    }
    if (this.borderedSelected) {
      classes.push('-borderedSelected');
    }

    return classes.join(' ').trim();
  }
}
